import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('FarcanaDailyBonusRow').create(() => ({
  root: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '141px',
    padding: '0px 15%',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    borderBottom: '1px solid black',

    '&[data-canclaim="false"]': {
      opacity: '0.5',
    },
  },
}))
